"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIsGift = exports.setFieldValue = exports.setFieldError = exports.selectDeliveryDetails = exports.resetDeliveryDetailsState = exports.initialState = exports.deliveryDetailsSlice = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
const initialState = exports.initialState = {
  isGift: false,
  recipientEmail: {
    value: '',
    error: '',
    translationKey: ''
  },
  confirmRecipientEmail: {
    value: '',
    error: '',
    translationKey: ''
  },
  deliveryDate: {
    value: '',
    error: '',
    translationKey: ''
  },
  deliveryTime: {
    value: '',
    error: '',
    translationKey: ''
  },
  message: {
    value: ''
  }
};
const deliveryDetailsSlice = exports.deliveryDetailsSlice = (0, _toolkit.createSlice)({
  name: 'deliveryDetails',
  initialState,
  reducers: {
    setIsGift: (state, action) => {
      state.isGift = action.payload;
    },
    setFieldValue: (state, action) => {
      const {
        payload: {
          name,
          value
        }
      } = action;
      state[name].value = value;
    },
    setFieldError: (state, action) => {
      const {
        payload: {
          name,
          error,
          translationKey
        }
      } = action;
      state[name].error = error;
      state[name].translationKey = translationKey;
    },
    resetDeliveryDetailsState: () => initialState
  }
});
const {
  setIsGift,
  setFieldValue,
  setFieldError,
  resetDeliveryDetailsState
} = deliveryDetailsSlice.actions;
exports.resetDeliveryDetailsState = resetDeliveryDetailsState;
exports.setFieldError = setFieldError;
exports.setFieldValue = setFieldValue;
exports.setIsGift = setIsGift;
const selectDeliveryDetails = state => state.deliveryDetails;
exports.selectDeliveryDetails = selectDeliveryDetails;
var _default = exports.default = deliveryDetailsSlice.reducer;